/**
 * Configuration for things shared across the front-ends.
 *
 * This file defines values internally rather then via env files because there is no easy way
 * to load env files outside of the default CRA way and that way that would collide with normal app env files.
 *
 * process.env is given priority so that the values can be overridden by the consuming apps if needed.
 * Values set in .env files in the consuming apps will override the values set here.
 * Values set in the environment at build time will override both as usual.
 */

const environments = {
    development: {
        REACT_APP_ROOT_DOMAIN: "127.0.0.1",
        REACT_APP_CENTRAL_BACKEND_URL: "http://127.0.0.1:5001/",
        REACT_APP_CENTRAL_FRONTEND_URL: "http://127.0.0.1:3001/",
        REACT_APP_PMG360_FRONTEND_URL: "http://127.0.0.1:3000/",
        REACT_APP_MARKETMINE_FRONTEND_URL: "http://127.0.0.1:3002/",
        REACT_APP_MARKETMINE_API_BASE_URL: "http://127.0.0.1:5002/api",
        REACT_APP_FHC_FRONTEND_URL: "http://127.0.0.1:3003/",
        REACT_APP_FHC_API_BASE_URL: "http://127.0.0.1:3004/api",
        REACT_APP_ADVICE_360_FRONTEND_URL: "http://127.0.0.1:3007/",
        REACT_APP_GROWTHSTUDY_FRONTEND_URL: "http://127.0.0.1:3012/",
        REACT_APP_GROWTHSTUDY_API_BASE_URL: "http://127.0.0.1:5012/api",
    },
    devserver: {
        REACT_APP_ROOT_DOMAIN: "pmg-apps.com",
        REACT_APP_CENTRAL_BACKEND_URL: "https://dev.pmg-apps.com/",
        REACT_APP_CENTRAL_FRONTEND_URL: "https://dev.pmg-apps.com/",
        REACT_APP_PMG360_FRONTEND_URL: "https://360dev.pmg-apps.com/",
        REACT_APP_MARKETMINE_FRONTEND_URL: "https://marketminedev.pmg-apps.com/",
        REACT_APP_MARKETMINE_API_BASE_URL: "https://marketminedev.pmg-apps.com/api",
        REACT_APP_FHC_FRONTEND_URL: "https://fhcdev.pmg-apps.com/",
        REACT_APP_FHC_API_BASE_URL: "https://fhcdev.pmg-apps.com/api",
        REACT_APP_GROWTHSTUDY_FRONTEND_URL: "https://growthstudydev.pmg-apps.com/",
        REACT_APP_GROWTHSTUDY_API_BASE_URL: "https://growthstudydev.pmg-apps.com/api",
    },
    test: {
        REACT_APP_ROOT_DOMAIN: "pmg-apps.com",
        REACT_APP_CENTRAL_BACKEND_URL: "https://test.pmg-apps.com/",
        REACT_APP_CENTRAL_FRONTEND_URL: "https://test.pmg-apps.com/",
        REACT_APP_PMG360_FRONTEND_URL: "https://360test.pmg-apps.com/",
        REACT_APP_MARKETMINE_FRONTEND_URL: "https://marketminetest.pmg-apps.com/",
        REACT_APP_MARKETMINE_API_BASE_URL: "https://marketminetest.pmg-apps.com/api",
        REACT_APP_FHC_FRONTEND_URL: "https://fhctest.pmg-apps.com/",
        REACT_APP_FHC_API_BASE_URL: "https://fhctest.pmg-apps.com/api",
        REACT_APP_GROWTHSTUDY_FRONTEND_URL: "https://growthstudytest.pmg-apps.com/",
        REACT_APP_GROWTHSTUDY_API_BASE_URL: "https://growthstudytest.pmg-apps.com/api",
    },
    production: {
        REACT_APP_ROOT_DOMAIN: "pmg-apps.com",
        REACT_APP_CENTRAL_BACKEND_URL: "https://pmg-apps.com/",
        REACT_APP_CENTRAL_FRONTEND_URL: "https://pmg-apps.com/",
        REACT_APP_PMG360_FRONTEND_URL: "https://360.pmg-apps.com/",
        REACT_APP_MARKETMINE_FRONTEND_URL: "https://marketmine.pmg-apps.com/",
        REACT_APP_MARKETMINE_API_BASE_URL: "https://marketmine.pmg-apps.com/api",
        REACT_APP_FHC_FRONTEND_URL: "https://fhc.pmg-apps.com/",
        REACT_APP_FHC_API_BASE_URL: "https://fhc.pmg-apps.com/api",
        REACT_APP_GROWTHSTUDY_FRONTEND_URL: "https://growthstudy.pmg-apps.com/",
        REACT_APP_GROWTHSTUDY_API_BASE_URL: "https://growthstudy.pmg-apps.com/api",
    },
};

let weak = environments[process.env.REACT_APP_NODE_ENV] || {};

//resolve value and warn if unset (priority: system > .env > internal)
const resolve = (envName) => process.env[envName] || weak[envName] || console.warn("no value set for " + envName + "!");

const config = {
    rootDomain: resolve("REACT_APP_ROOT_DOMAIN"),
    centralBackendURL: resolve("REACT_APP_CENTRAL_BACKEND_URL"),
    centralFrontendURL: resolve("REACT_APP_CENTRAL_FRONTEND_URL"),
    pmg360FrontendURL: resolve("REACT_APP_PMG360_FRONTEND_URL"),
    marketmineFrontendURL: resolve("REACT_APP_MARKETMINE_FRONTEND_URL"),
    marketmineBackendURL: resolve("REACT_APP_MARKETMINE_API_BASE_URL"),
    fhcFrontendURL: resolve("REACT_APP_FHC_FRONTEND_URL"),
    fhcBackendURL: resolve("REACT_APP_FHC_API_BASE_URL"),
    advice360FrontendURL: resolve("REACT_APP_ADVICE_360_FRONTEND_URL"),
    growthStudyFrontendURL: resolve("REACT_APP_GROWTHSTUDY_FRONTEND_URL"),
    growthStudyBackendURL: resolve("REACT_APP_GROWTHSTUDY_API_BASE_URL"),
};

export default config;
